import React, { useState } from 'react'
import { useRouter } from 'next/router'

//* HOCs
import { withDataContext, withUIContext } from 'context'

//* Components
import { FormContainer, Input, ButtonSimple, Text, Popup, Icon } from 'components/common'
import { Form, Radio } from 'antd'

const ContactUs = ({ contactUs, toggleContactPopup, contactPopupIsOpen, enableDomScroll, ...props }) => {
    //! Router
    const router = useRouter()

    //! State
    const [thankYou, setThankYou] = useState(false)

    //! On Form Submit
    const onSubmit = (values) => {
        return contactUs(values).then(() => setThankYou(true))
    }

    //! On Explore button click
    const explore = () => {
        enableDomScroll()
        router.push('/')
    }

    return (
        <Popup
            functionClose={() => { toggleContactPopup(), setThankYou(false) }}
            className={`${props.className ? 'active' : ''}`}
            popupIsOpen={contactPopupIsOpen}
        >
            <FormContainer className={`flexBoxColumn ${thankYou && 'thank-you'}`} onFinish={onSubmit}>
                {!thankYou && <Text tag="h3" className="title h3 PopSemi" text="Contact us" />}
                <Icon className="op-close cursorPointer" onClick={() => { toggleContactPopup(), setThankYou(false), enableDomScroll() }} />
                {!thankYou &&
                    <>
                        <div className="halfInputs flexBox">
                            <Input label={'First Name'} name={'first_name'} />
                            <Input label={'Last Name'} name={'last_name'} />
                        </div>
                        <div className="halfInputs flexBox">
                            <Input label={'Email address'} name={'email'} />
                            <Input label={'Phone Number'} name={'phone'} />
                        </div>
                        <Form.Item className='radio' label={'Your enquiry is related to enterprise button'} name={'enquiry'}>
                            <Radio.Group>
                                <Radio value={'yes'}>Yes</Radio>
                                <Radio value={'no'}>No</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Input placeholder={'I’m interested in learning more about...'} type={'textarea'}
                            label={'Reason for Contacting'} name={'reason'} />
                        <ButtonSimple submit text="Submit" />
                    </>
                }
                {thankYou &&
                    <div className="thank-you flexBoxColumn alignMiddle">
                        <Text tag={'p'} className="NewYork h13" text="Thank you!" />
                        <Text tag={'h3'} className="sub PopReg h3" text="Someone from our team will contact you soon" />
                        <ButtonSimple
                            onClick={explore}
                            text="Explore Oplos"
                        />
                    </div>
                }
            </FormContainer>
        </Popup>
    )
}

export default withUIContext(withDataContext(ContactUs, ['contactUs']), ['toggleContactPopup', 'contactPopupIsOpen', 'enableDomScroll'])
